import React, { Component } from "react";
import TableData from "../tableData";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Search from "../searchComponent";
import { ALL } from "../../../store/types";
import { connect } from "react-redux";
import { getInvestors } from "../../../store/actions";
import { MAILBACK_URL } from ".";
import Image from "../../Image";

class InvestorSelection extends Component {
  componentDidMount() {
    this.props.getInvestors({
      ARN: this.props.token,
      customfund: "189",
      AllFavFlag: "A",
    });
  }

  render() {
    return (
      <div className="container-margin">
        <div className="tab-breadcrumbs-container" style={{ marginTop: 0 }}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="Breadcrumb"
          >
            <div className="flex-for-settings">
              <Image
                src={"/images/bajaj_web-page-home.svg"}
                alt="web-page-home"
                style={{ height: 20, marginRight: 10 }}
              />
              <div
                onClick={() =>
                  this.props.history.push(MAILBACK_URL + "/investor")
                }
                className="breadcrumbs-unselect-label"
              >
                Mailback Types
                {/* {!!this.props.location &&
              this.props.location.state.name === "consolidated"
                ? "Consolidated Account Statement"
                : this.props.location.state.name === "ELSS"
                ? "ELSS Account Statment"
                : this.props.location.state.name === "CAN"
                ? "CAN Based Account Statment"
                : this.props.location.state.name === "CGS"
                ? "Capital Gains Statment"
                : this.props.location.state.name === "GAS"
                ? "Grandfathering Account Statment"
                : this.props.location.state.name === "Networth"
                ? "Networth Report"
                : "Mail back Types"} */}
              </div>
              {/* <div
                color="inherit"
                className="breadcrumbs-unselect-label"
                onClick={() => this.props.history.push(MAILBACK_URL)}
              >
                Mail Back Request
              </div> */}
            </div>

            <div className="transaction-summary-label">Investors Selection</div>
          </Breadcrumbs>
        </div>
        <Search history={this.props.history} />
        <TableData
          history={this.props.history}
          location={this.props.location}
          name="mailback"
        />
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { token } = authReducer;
    return { token };
  },
  { getInvestors }
)(InvestorSelection);
